import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import Recaptcha from 'react-google-recaptcha';
import NewApi from './newapi';
import DeleteApi from './deleteapi';
import SvgBin from '../../icons/svgBin';

import {
  createToken,
  fetchTokens,
  deleteToken,
} from '../../actions';

const dateFormat = 'L LT';

class Api extends Component {
  constructor(props) {
    super(props);
    this.state = {
      scope: 'read',
      deleteMode: true,
      recaptchaRef: React.createRef(),
    };
    this.tokenDelete = this.tokenDelete.bind(this);
    this.resize = this.resize.bind(this);
    this.onSubmitWithReCAPTCHA = this.onSubmitWithReCAPTCHA.bind(this);
    this.handleTokenChange = this.handleTokenChange.bind(this);
    this.handleScopeChange = this.handleScopeChange.bind(this);
    this.onCaptchaChange = this.onCaptchaChange.bind(this);
  }

  componentDidMount() {
    // window.addEventListener('resize', this.resize);
    // if (window.innerWidth > 720 && !this.state.deleteMode) {
    //   this.setState({
    //     deleteMode: true,
    //   });
    // }

    const { dispatch } = this.props;
    dispatch(fetchTokens());
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize);
  }

  async onSubmitWithReCAPTCHA(event) {
    event.preventDefault();
    const token = await this.state.recaptchaRef.current.executeAsync();
  }

  onCaptchaChange() {
    const { recaptchaRef, expires, scope } = this.state;
    const recaptchaValue = recaptchaRef.current.getValue();

    const data = {
      expires,
      scope,
      captcha: recaptchaValue,
    };

    const { dispatch } = this.props;
    dispatch(createToken(data))
      .then((res) => {
        if (res.type === 'CREATE_TOKEN_SUCCESS') {
          dispatch(fetchTokens());
          this.props.toggleModal(<NewApi toggleModal={this.props.toggleModal} modalComponent={this.state.modalComponent} />);
        }
        return;
      });
  }

  handleTokenChange(event) {
    this.setState({ api_token: event.target.value });
  }

  handleScopeChange(event) {
    this.setState({ scope: event.target.value });
  }

  resize() {
    if (window.innerWidth > 720 && !this.state.deleteMode) {
      this.setState({
        deleteMode: true,
      });
    }
  }

  tokenDelete(id) {
    const { dispatch } = this.props;
    dispatch(deleteToken(id))
      .then((res) => {
        dispatch(fetchTokens());
      });
  }

  showError(e) {
    console.log('Error with the captcha');
  }

  render() {
    const { apitokens, tempAnon } = this.props;

    const { deleteMode, recaptchaRef } = this.state;

    // let tokenLoop;

    const tokenLoop = apitokens && apitokens.map((item, index) => {

      let createdAt;
      let expiresAt;
      let refId;

      if (item && item.referenceId) {
        refId = item.referenceId
      }

      if (item && item.createdAt) {
        createdAt = moment.unix(item.createdAt).format(dateFormat)
      }

      if (item && item.expires) {
        expiresAt = moment.unix(item.expires).format(dateFormat)
      }

      return (
        <tr key={index}>
          <td style={{ textAlign: 'left' }}>
            <span className={tempAnon ? 'eyeblur' : ''}>
              {refId}
            </span>
          </td>
          <td className="hide-mob">{createdAt}</td>
          <td>{expiresAt}</td>
          {deleteMode &&
            <td>
              <div className="del-icon"   onClick={() => this.tokenDelete(refId)}>
                <SvgBin style={{height: 20, width: 20, marginRight: 4}} />
              </div>
            </td>
          }
        </tr>
      );
    })

    return (
      <div className="cell panel v2 small-12 medium-12 large-12">
        <div className="grid-x" style={{marginBottom: 16}}>
          <div className="cell small-6 medium-6 large-6">
            <div className="panel-label">
              API Tokens
            </div>
          </div>
          <div className="cell small-6 medium-6 large-6 flex-end">
            <form onSubmit={this.onSubmitWithReCAPTCHA} id="newToken">
              <Recaptcha
                ref={recaptchaRef}
                sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
                onChange={this.onCaptchaChange}
                size="invisible"
                onExpired={() => {}}
                onErrored={(e) => {
                  this.showError(e);
                }}
              />
              <div className="grid-x align-middle group g-xl">
                <button className="vlt-btn vlt-btn-outline" type="submit" form="newToken" >
                  <span>
                    Create Token
                  </span>
                </button>
              </div>
            </form>
          </div>
        </div>

        <div className="grid-x">
          <div className="cell small-12 medium-12 large-12">
            {apitokens && apitokens.length ? (
              <div>
                <table>
                  <thead>
                    <tr>
                      <th style={{ textAlign: 'left' }}>Token Reference</th>
                      <th className="hide-mob">Created At</th>
                      <th>Expires At</th>
                      {deleteMode && <th></th> }
                    </tr>
                  </thead>
                  <tbody>
                    {tokenLoop}
                  </tbody>
                </table>
                {/* <div className="mobile-del-btn" style={{ marginTop: 16 }}>
                  <button className="vlt-button dark-b" onClick={() => this.props.toggleModal(<DeleteApi toggleModal={this.props.toggleModal} modalComponent={this.state.modalComponent} tokenDelete={this.tokenDelete}/>)}>Edit Tokens</button>
                </div> */}
              </div>
            ) : (
              <div>
                <table>
                  <thead>
                    <tr>
                      <th style={{ textAlign: 'left' }}>Token Reference</th>
                      <th className="hide-mob">Created At</th>
                      <th>Expires At</th>
                      {deleteMode && <th></th> }
                    </tr>
                  </thead>
                </table>
                <h3 className="no-data">No API Tokens</h3>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  errors: state.user.errors,
  newtoken: state.user.newtoken,
  apitokens: state.user.apitokens,
  tempAnon: state.user.tempAnon,
});

export default connect(mapStateToProps)(Api);
